module.exports = __webpack_public_path__ + "static/media/geoSocialSentimentSimple.4630faca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/geoSocialSentimentSimple.png
// module id = 174
// module chunks = 0